import { render, staticRenderFns } from "./ownerExpensesRegister.vue?vue&type=template&id=49f864b2&scoped=true"
import script from "./ownerExpensesRegister.vue?vue&type=script&lang=js"
export * from "./ownerExpensesRegister.vue?vue&type=script&lang=js"
import style0 from "./ownerExpensesRegister.vue?vue&type=style&index=0&id=49f864b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49f864b2",
  null
  
)

export default component.exports